import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

const BoardsPublicTemplatesLoadingRouteTemplate: TOC<object> = <template>
	<SkeletonScreenComponent @type="tiles" @item="board" />
</template>;

export default BoardsPublicTemplatesLoadingRouteTemplate;
